import React from 'react'

/** The column a table is currently ranked by: its header carries the sorted-header treatment and its cells are bold. */
export const rankingColumnProps = (active: boolean) =>
    active
        ? {
              className: 'org-dashboard-ranking-column',
              onHeaderCell: (): React.HTMLAttributes<HTMLElement> => ({ 'aria-sort': 'descending' }),
          }
        : {}
